import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { TaskList } from './TaskList';
import { TaskCreate } from './TaskCreate';
import { TaskEdit } from './TaskEdit';
import AuthRoute from 'containers/AuthRoute';
import { EUserType } from 'services/BackendApi';

const ALLOWED_USER_TYPES = [EUserType.ADMIN, EUserType.SR, EUserType.TA, EUserType.FINANCE, EUserType.RL];

export interface TaskManagementRoutingProps extends RouteComponentProps {}

export const TaskManagementRoutingComponent = (props: TaskManagementRoutingProps) => {
  return (
    <Switch>
      <AuthRoute exact allow={ALLOWED_USER_TYPES} path={props.match.path} component={TaskList} />
      <AuthRoute exact allow={[...ALLOWED_USER_TYPES, EUserType.SALES]} path={`${props.match.path}/create`} component={TaskCreate} />
      <AuthRoute exact allow={[...ALLOWED_USER_TYPES, EUserType.SALES]} path={`${props.match.path}/:taskId/edit`} component={TaskEdit} />
    </Switch>
  );
};

export const TaskManagementRouting = compose(withRouter)(TaskManagementRoutingComponent);
